module.exports = __webpack_public_path__ + "img/dna-spiral.3c09863.webp";